// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================= */
/* COMMAND PALETTE — PROFESSIONAL SEARCH        */
/* ============================================= */

/* Overlay */
.cp-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 12vh;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

/* Container */
.cp-container {
  width: 100%;
  max-width: 560px;
  margin: 0 1rem;
  background: #FFFFFF;
  border-radius: 1rem;
  border: 1px solid #E2E8F0;
  box-shadow:
    0 25px 60px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 480px;
}

.cp-dark {
  background: #1E293B;
  border-color: #334155;
  box-shadow:
    0 25px 60px rgba(0, 0, 0, 0.5),
    0 0 0 1px rgba(255, 255, 255, 0.03);
}

/* ---- Search Input ---- */
.cp-input-wrapper {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1.25rem;
  border-bottom: 1px solid #F1F5F9;
}

.cp-dark .cp-input-wrapper {
  border-bottom-color: #334155;
}

.cp-input-icon {
  width: 1.25rem;
  height: 1.25rem;
  color: #94A3B8;
  flex-shrink: 0;
}

.cp-dark .cp-input-icon {
  color: #64748B;
}

.cp-input {
  flex: 1 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.9375rem;
  font-weight: 400;
  color: #0F172A;
  line-height: 1.5;
}

.cp-dark .cp-input {
  color: #F1F5F9;
}

.cp-input::placeholder {
  color: #94A3B8;
}

.cp-dark .cp-input::placeholder {
  color: #475569;
}

.cp-esc-badge {
  font-size: 0.625rem;
  font-weight: 600;
  font-family: system-ui, sans-serif;
  padding: 0.125rem 0.4rem;
  border-radius: 0.25rem;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  color: #94A3B8;
  line-height: 1.3;
  flex-shrink: 0;
}

.cp-dark .cp-esc-badge {
  border-color: #475569;
  background: #0F172A;
  color: #64748B;
}

/* ---- Results ---- */
.cp-results {
  flex: 1 1;
  overflow-y: auto;
  padding: 0.375rem;
}

.cp-results::-webkit-scrollbar {
  width: 5px;
}

.cp-results::-webkit-scrollbar-track {
  background: transparent;
}

.cp-results::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 4px;
}

.cp-dark .cp-results::-webkit-scrollbar-thumb {
  background: #475569;
}

/* Section Label */
.cp-section-label {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94A3B8;
  padding: 0.625rem 0.75rem 0.375rem;
}

.cp-dark .cp-section-label {
  color: #64748B;
}

.cp-section-icon {
  width: 0.875rem;
  height: 0.875rem;
}

/* Result Item */
.cp-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.625rem 0.75rem;
  border: none;
  border-radius: 0.5rem;
  background: transparent;
  cursor: pointer;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #374151;
  text-align: left;
  transition: all 100ms ease;
}

.cp-dark .cp-item {
  color: #CBD5E1;
}

.cp-item:hover,
.cp-item-selected {
  background: #F8FAFC;
}

.cp-dark .cp-item:hover,
.cp-dark .cp-item-selected {
  background: #334155;
}

.cp-item-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  background: #F1F5F9;
  color: #64748B;
  flex-shrink: 0;
  transition: all 100ms ease;
}

.cp-dark .cp-item-icon-wrap {
  background: #1E293B;
  color: #94A3B8;
}

.cp-item-selected .cp-item-icon-wrap {
  background: #E0E7FF;
  color: #4338CA;
}

.cp-dark .cp-item-selected .cp-item-icon-wrap {
  background: #1E293B;
  color: #818CF8;
}

.cp-item-icon {
  width: 1rem;
  height: 1rem;
}

.cp-item-name {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cp-item-path {
  font-size: 0.6875rem;
  font-weight: 400;
  color: #94A3B8;
  flex-shrink: 0;
}

.cp-dark .cp-item-path {
  color: #475569;
}

.cp-item-arrow {
  width: 0.875rem;
  height: 0.875rem;
  flex-shrink: 0;
  opacity: 0;
  transition: opacity 100ms ease;
}

.cp-item-selected .cp-item-arrow {
  opacity: 1;
}

/* Highlight */
.cp-highlight {
  font-weight: 700;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 2px;
}

/* Empty State */
.cp-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1rem;
  gap: 0.5rem;
}

.cp-empty-icon {
  width: 2.5rem;
  height: 2.5rem;
  color: #CBD5E1;
}

.cp-dark .cp-empty-icon {
  color: #475569;
}

.cp-empty-text {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748B;
}

.cp-dark .cp-empty-text {
  color: #94A3B8;
}

.cp-empty-hint {
  margin: 0;
  font-size: 0.75rem;
  color: #94A3B8;
}

.cp-dark .cp-empty-hint {
  color: #64748B;
}

/* ---- Footer ---- */
.cp-footer {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 0.625rem 1.25rem;
  border-top: 1px solid #F1F5F9;
  background: #FAFBFC;
}

.cp-dark .cp-footer {
  border-top-color: #334155;
  background: #0F172A;
}

.cp-footer-hint {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.6875rem;
  color: #94A3B8;
}

.cp-dark .cp-footer-hint {
  color: #64748B;
}

.cp-kbd {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.375rem;
  height: 1.25rem;
  padding: 0 0.25rem;
  font-size: 0.625rem;
  font-weight: 600;
  font-family: system-ui, sans-serif;
  color: #64748B;
  background: #F1F5F9;
  border: 1px solid #E2E8F0;
  border-radius: 0.25rem;
  line-height: 1;
}

.cp-dark .cp-kbd {
  color: #94A3B8;
  background: #1E293B;
  border-color: #334155;
}

/* ---- Responsive ---- */
@media (max-width: 639px) {
  .cp-overlay {
    padding-top: 5vh;
  }

  .cp-container {
    max-height: 70vh;
    border-radius: 0.75rem;
  }

  .cp-footer {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/styles/CommandPalette.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD,iDAAiD;AACjD,kDAAkD;;AAElD,YAAY;AACZ;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB;;iCAE+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB;;uCAEqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ============================================= */\n/* COMMAND PALETTE — PROFESSIONAL SEARCH        */\n/* ============================================= */\n\n/* Overlay */\n.cp-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 12vh;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n\n/* Container */\n.cp-container {\n  width: 100%;\n  max-width: 560px;\n  margin: 0 1rem;\n  background: #FFFFFF;\n  border-radius: 1rem;\n  border: 1px solid #E2E8F0;\n  box-shadow:\n    0 25px 60px rgba(0, 0, 0, 0.15),\n    0 0 0 1px rgba(0, 0, 0, 0.03);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  max-height: 480px;\n}\n\n.cp-dark {\n  background: #1E293B;\n  border-color: #334155;\n  box-shadow:\n    0 25px 60px rgba(0, 0, 0, 0.5),\n    0 0 0 1px rgba(255, 255, 255, 0.03);\n}\n\n/* ---- Search Input ---- */\n.cp-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.875rem 1.25rem;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.cp-dark .cp-input-wrapper {\n  border-bottom-color: #334155;\n}\n\n.cp-input-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n  color: #94A3B8;\n  flex-shrink: 0;\n}\n\n.cp-dark .cp-input-icon {\n  color: #64748B;\n}\n\n.cp-input {\n  flex: 1;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 0.9375rem;\n  font-weight: 400;\n  color: #0F172A;\n  line-height: 1.5;\n}\n\n.cp-dark .cp-input {\n  color: #F1F5F9;\n}\n\n.cp-input::placeholder {\n  color: #94A3B8;\n}\n\n.cp-dark .cp-input::placeholder {\n  color: #475569;\n}\n\n.cp-esc-badge {\n  font-size: 0.625rem;\n  font-weight: 600;\n  font-family: system-ui, sans-serif;\n  padding: 0.125rem 0.4rem;\n  border-radius: 0.25rem;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  color: #94A3B8;\n  line-height: 1.3;\n  flex-shrink: 0;\n}\n\n.cp-dark .cp-esc-badge {\n  border-color: #475569;\n  background: #0F172A;\n  color: #64748B;\n}\n\n/* ---- Results ---- */\n.cp-results {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0.375rem;\n}\n\n.cp-results::-webkit-scrollbar {\n  width: 5px;\n}\n\n.cp-results::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.cp-results::-webkit-scrollbar-thumb {\n  background: #CBD5E1;\n  border-radius: 4px;\n}\n\n.cp-dark .cp-results::-webkit-scrollbar-thumb {\n  background: #475569;\n}\n\n/* Section Label */\n.cp-section-label {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #94A3B8;\n  padding: 0.625rem 0.75rem 0.375rem;\n}\n\n.cp-dark .cp-section-label {\n  color: #64748B;\n}\n\n.cp-section-icon {\n  width: 0.875rem;\n  height: 0.875rem;\n}\n\n/* Result Item */\n.cp-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0.625rem 0.75rem;\n  border: none;\n  border-radius: 0.5rem;\n  background: transparent;\n  cursor: pointer;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #374151;\n  text-align: left;\n  transition: all 100ms ease;\n}\n\n.cp-dark .cp-item {\n  color: #CBD5E1;\n}\n\n.cp-item:hover,\n.cp-item-selected {\n  background: #F8FAFC;\n}\n\n.cp-dark .cp-item:hover,\n.cp-dark .cp-item-selected {\n  background: #334155;\n}\n\n.cp-item-icon-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 0.5rem;\n  background: #F1F5F9;\n  color: #64748B;\n  flex-shrink: 0;\n  transition: all 100ms ease;\n}\n\n.cp-dark .cp-item-icon-wrap {\n  background: #1E293B;\n  color: #94A3B8;\n}\n\n.cp-item-selected .cp-item-icon-wrap {\n  background: #E0E7FF;\n  color: #4338CA;\n}\n\n.cp-dark .cp-item-selected .cp-item-icon-wrap {\n  background: #1E293B;\n  color: #818CF8;\n}\n\n.cp-item-icon {\n  width: 1rem;\n  height: 1rem;\n}\n\n.cp-item-name {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cp-item-path {\n  font-size: 0.6875rem;\n  font-weight: 400;\n  color: #94A3B8;\n  flex-shrink: 0;\n}\n\n.cp-dark .cp-item-path {\n  color: #475569;\n}\n\n.cp-item-arrow {\n  width: 0.875rem;\n  height: 0.875rem;\n  flex-shrink: 0;\n  opacity: 0;\n  transition: opacity 100ms ease;\n}\n\n.cp-item-selected .cp-item-arrow {\n  opacity: 1;\n}\n\n/* Highlight */\n.cp-highlight {\n  font-weight: 700;\n  text-decoration: underline;\n  text-decoration-thickness: 2px;\n  text-underline-offset: 2px;\n}\n\n/* Empty State */\n.cp-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2.5rem 1rem;\n  gap: 0.5rem;\n}\n\n.cp-empty-icon {\n  width: 2.5rem;\n  height: 2.5rem;\n  color: #CBD5E1;\n}\n\n.cp-dark .cp-empty-icon {\n  color: #475569;\n}\n\n.cp-empty-text {\n  margin: 0;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #64748B;\n}\n\n.cp-dark .cp-empty-text {\n  color: #94A3B8;\n}\n\n.cp-empty-hint {\n  margin: 0;\n  font-size: 0.75rem;\n  color: #94A3B8;\n}\n\n.cp-dark .cp-empty-hint {\n  color: #64748B;\n}\n\n/* ---- Footer ---- */\n.cp-footer {\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n  padding: 0.625rem 1.25rem;\n  border-top: 1px solid #F1F5F9;\n  background: #FAFBFC;\n}\n\n.cp-dark .cp-footer {\n  border-top-color: #334155;\n  background: #0F172A;\n}\n\n.cp-footer-hint {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  font-size: 0.6875rem;\n  color: #94A3B8;\n}\n\n.cp-dark .cp-footer-hint {\n  color: #64748B;\n}\n\n.cp-kbd {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.375rem;\n  height: 1.25rem;\n  padding: 0 0.25rem;\n  font-size: 0.625rem;\n  font-weight: 600;\n  font-family: system-ui, sans-serif;\n  color: #64748B;\n  background: #F1F5F9;\n  border: 1px solid #E2E8F0;\n  border-radius: 0.25rem;\n  line-height: 1;\n}\n\n.cp-dark .cp-kbd {\n  color: #94A3B8;\n  background: #1E293B;\n  border-color: #334155;\n}\n\n/* ---- Responsive ---- */\n@media (max-width: 639px) {\n  .cp-overlay {\n    padding-top: 5vh;\n  }\n\n  .cp-container {\n    max-height: 70vh;\n    border-radius: 0.75rem;\n  }\n\n  .cp-footer {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
